/**
 * カート内に「同時注文不可」タグ商品と他商品が混在している場合、
 * ・該当行にNG赤字を表示
 * ・チェックアウトボタン(name="checkout")を非活性化
 * ・アラート表示(ページ読み込み完了後 / チェックアウト送信時)
 *
 * 前提: main-cart.liquid 側で
 *   <table class="order-summary" data-ng-mixed="true/false">
 *   <tr data-ng-tag="true/false">
 * を出力していること
 */
(function () {
  'use strict';

  var WARNING_TEXT = '同時注文不可商品です';
  var WARNING_CLASS = 'ng-cooccurrence-warning';
  var ALERT_MESSAGE =
    'こちらの商品は他商品と同時に注文ができません。\n' +
    'お手数ですがカートを空にするか個別にご注文ください。';

  var wasMixed = false;
  var initialAlertDone = false;

  // is-disabled の見た目用スタイルを注入(既にCSSで定義済みなら不要)
  if (!document.getElementById('ng-cooccurrence-style')) {
    var style = document.createElement('style');
    style.id = 'ng-cooccurrence-style';
    style.textContent =
      '[name="checkout"].is-disabled{opacity:.5;cursor:not-allowed;}';
    document.head.appendChild(style);
  }

  function getTable() {
    return document.querySelector('table.order-summary');
  }

  function isMixedNow() {
    var table = getTable();
    return !!table && table.getAttribute('data-ng-mixed') === 'true';
  }

  // DOM反映(非活性化・赤字表示)のみ。アラートはここでは出さない。
  function applyDom() {
    var table = getTable();
    if (!table) return false;

    var mixed = isMixedNow();
    setCheckoutDisabled(mixed);

    if (mixed) {
      markNgRows(table);
    } else {
      clearWarnings();
    }
    return mixed;
  }

  function markNgRows(table) {
    var rows = table.querySelectorAll('tbody.order-summary__body > tr[data-ng-tag="true"]');
    rows.forEach(function (row) {
      var info = row.querySelector('.line-item__info');
      if (!info || info.querySelector('.' + WARNING_CLASS)) return; // 重複防止

      var targetP = info.querySelector('p.text-sm.text-subdued');
      var warning = document.createElement('p');
      warning.className = WARNING_CLASS + ' text-sm';
      warning.style.cssText = 'color:#e02424;font-weight:bold;';
      warning.textContent = WARNING_TEXT;

      if (targetP) {
        info.insertBefore(warning, targetP);
      } else {
        info.prepend(warning);
      }
    });
  }

  function clearWarnings() {
    document.querySelectorAll('.' + WARNING_CLASS).forEach(function (el) {
      el.remove();
    });
  }

  function setCheckoutDisabled(disabled) {
    document.querySelectorAll('[name="checkout"]').forEach(function (btn) {
      // 注意: btn.disabled = true にすると、ブラウザ仕様上そのボタンの
      // click / submit イベントが一切発火しなくなり、クリック時のアラートが
      // 出せなくなる。そのため見た目のみ非活性化し、実際のブロックは
      // submit / click ハンドラー側(下記4,5)で行う。
      btn.classList.toggle('is-disabled', disabled);
      btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    });
  }

  function whenDomReady(cb) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', cb);
    } else {
      cb();
    }
  }

  // 1) 非活性化・赤字表示はなるべく早く反映
  whenDomReady(function () {
    applyDom();
  });

  // 2) ページ読み込み完了後、初回だけ「混在していればアラート」
  function onFullyLoaded() {
    var mixed = applyDom();
    if (mixed && !initialAlertDone) {
      alert(ALERT_MESSAGE);
      initialAlertDone = true;
    }
    wasMixed = mixed;
  }
  if (document.readyState === 'complete') {
    onFullyLoaded();
  } else {
    window.addEventListener('load', onFullyLoaded);
  }

  // 3) 数量変更等でカート部分がAJAX再描画された場合、新たに混在になったらアラート
  var observer = new MutationObserver(function (mutations) {
    var relevant = mutations.some(function (m) {
      function isOwnWarning(n) {
        return n.nodeType === 1 && n.classList && n.classList.contains(WARNING_CLASS);
      }
      return (
        Array.prototype.some.call(m.addedNodes, function (n) { return !isOwnWarning(n); }) ||
        Array.prototype.some.call(m.removedNodes, function (n) { return !isOwnWarning(n); })
      );
    });
    if (!relevant) return;

    var mixed = applyDom();
    if (mixed && !wasMixed) {
      alert(ALERT_MESSAGE);
    }
    wasMixed = mixed;
  });

  whenDomReady(function () {
    var container = document.querySelector('.cart-order__summary') || document.body;
    observer.observe(container, { childList: true, subtree: true });
  });

  // 4) チェックアウト送信時に、その場の描画状態ではなく「今まさに最新のカート状態」を
  //    サーバーへ再取得して判定する。カートページを開いたまま他の経路(別タブ等)で
  //    商品が追加され、この画面のDOMが更新されていないケースに対応するため。
  var bypassNextSubmit = false;

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement)) return;

      var submitter = e.submitter;
      var isCheckoutSubmit =
        !submitter ||
        submitter.name === 'checkout' ||
        (submitter.closest && submitter.closest('[name="checkout"]'));
      if (!isCheckoutSubmit) return;

      if (bypassNextSubmit) {
        // 直前の再チェックで問題なしと確認済みの送信は素通しする
        bypassNextSubmit = false;
        return;
      }

      e.preventDefault();
      e.stopImmediatePropagation();

      if (isMixedNow()) {
        // 画面上すでに混在ありと分かっている(非活性表示済み)場合は
        // 再フェッチ・リロードはせず、アラートのみ出す
        alert(ALERT_MESSAGE);
        return;
      }

      // 画面上は問題なさそうに見える場合のみ、最新のカート状態を裏側で確認する
      verifyLatestCartThenProceed(form, submitter);
    },
    true
  );

  function verifyLatestCartThenProceed(form, submitter) {
    fetch(window.location.href, { cache: 'no-store', credentials: 'same-origin' })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var freshTable = doc.querySelector('table.order-summary');
        var freshMixed = !!freshTable && freshTable.getAttribute('data-ng-mixed') === 'true';

        if (freshMixed) {
          alert(ALERT_MESSAGE);
          // 画面上の表示(赤字・非活性)を最新状態に合わせるためカートを再読み込みする
          location.reload();
          return;
        }

        // 問題なければ元の送信を再実行してチェックアウトへ進める
        bypassNextSubmit = true;
        if (submitter && typeof submitter.click === 'function') {
          submitter.click();
        } else {
          form.submit();
        }
      })
      .catch(function () {
        // 最新状態が取得できない場合は安全側に倒し、遷移させない
        alert(ALERT_MESSAGE);
      });
  }
})();
